import '@cloudscape-design/global-styles/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './accessibility.css';
import './index.css';
import { registerServiceWorker } from './utils/service-worker.utils';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support (production only)
// This is optional and can be disabled if offline support is not needed
if (import.meta.env.MODE === 'production') {
  registerServiceWorker().catch((error) => {
    console.error('Service worker registration failed:', error);
  });
}
